import { combineReducers } from 'redux';

import dataset from './dataset';
import summary from './summary';
import parameters from './parameters';

export default combineReducers({
  dataset,
  summary,
  parameters
});
